import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

// Sistema de diseño
import './assets/design-system.css'

const app = createApp(App)

// Plugins
app.use(router)

// Directiva lazy-load: usa loading="lazy" nativo + IntersectionObserver como refuerzo
app.directive('lazy', {
  mounted(el, binding) {
    if (!binding.value) return

    el.setAttribute('loading', 'lazy')
    el.setAttribute('decoding', 'async')

    if (!('IntersectionObserver' in window)) {
      el.src = binding.value
      return
    }

    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            el.src = binding.value
            obs.unobserve(el)
          }
        })
      },
      { rootMargin: '200px' }
    )
    observer.observe(el)
  }
})

// Variables globales
app.config.globalProperties.$emailMarketing = {
  apiBase: '/api/bulk-mail'
}

app.mount('#app')